import { GetPatientsOfProfessionalResponsePayload } from "pokal_api"

function mockPatient(): GetPatientsOfProfessionalResponsePayload {
    return [
        {
            id: "mock_patient_id",
            gender: "male",
            bmi: 23,
            lastName: "Mustermann",
            firstName: "Max",
            birthdate: new Date(new Date().setFullYear(1999, 4, 2)),
            hideLongtermData: true
        }
    ]
}

export default mockPatient
